module.exports = __webpack_public_path__ + "img/ears_female.e247b5d4.png";